// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__14g4U","inputDescription":"styles_inputDescription__1FJYx"};